import React, { useState, useEffect } from 'react';

const CookieConsent = () => {
  const [showBanner, setShowBanner] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem('cookieConsent');
    if (!consent) {
      setShowBanner(true);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem('cookieConsent', 'accepted');
    setShowBanner(false);
  };

  return (
    showBanner && (
      <div className="fixed bottom-0 left-0 w-full bg-secondary text-white p-4 flex flex-col sm:flex-row justify-between items-center gap-3 z-50">
        <p className="text-sm sm:text-base">
          We use cookies to enhance your experience. By continuing to visit this site you agree to our use of cookies. 
          <a href="/legal" className="underline hover:text-white/80 ml-1">View our Privacy Policy</a>.
        </p>
        <button onClick={handleAccept} className="bg-primary hover:bg-primary/80 text-white font-bold py-2 px-4 rounded whitespace-nowrap">
          Accept
        </button>
      </div>
    )
  );
};

  
export default CookieConsent;
